import { object } from 'zod/mini';
import type { infer as Infer } from 'zod/mini';
import { textField, withDefaults } from '@h20-shared/dashboards';

export const TABLEAU_CONFIG_SCHEMA = withDefaults(
    object({
        /** The view's path, such as `Workbook/Sheet`. An author may paste a whole URL instead. */
        viewUrl: textField('Dashboard.TableauViewUrl'),
    })
);

export type TableauWidgetConfig = Infer<typeof TABLEAU_CONFIG_SCHEMA>;
